import { useQuery } from '@mint-lib/query-client';
import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

import { FlowTypes } from '../../constants/shared.js';

type Options = {
  entityType: FlowTypes;
  entityId: string;
  entitySource: string;
};

const useGetFlowStatusData = ({
  entityId,
  entityType,
  entitySource,
}: Options) => {
  return useQuery({
    ...ApprovalFlows.checkFlowStatus({
      params: { entityId, entityType, entitySource },
    }),
    staleTime: 30_000, // 30s
    select: (data) => data.data?.items?.[0],
  });
};

export default useGetFlowStatusData;
